import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import Toast from 'primevue/toast';
import { useStore } from 'vuex';
import { useNotifications, notifications } from '@/store/modules/notifications/useNotifications';
import Notification from '@/views/layout/notifications/Notification.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const { state } = useStore();
const { removeNotification } = useNotifications();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast), {
      class: "notifications",
      position: _unref(state).layout.isMobile ? 'bottom-center' : 'top-right',
      style: _normalizeStyle(!_unref(state).layout.isMobile ? 'bottom: unset' : '')
    }, null, 8, ["position", "style"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (item) => {
      return (_openBlock(), _createBlock(Notification, {
        options: item,
        key: item.id,
        onCloseNotification: ($event: any) => (_unref(removeNotification)(item.id))
      }, null, 8, ["options", "onCloseNotification"]))
    }), 128))
  ], 64))
}
}

})